import { DeliveryNoteParams } from '../models';

export class DeliveryNoteItemSetParams {
  public static readonly type = '[DeliveryNoteItem] Set Delivery Note Params';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteItemInitialState {
  public static readonly type = '[DeliveryNoteItem] Set initial state';
}
